import { ABWESENHEIT_DELETE } from '@/domain/arbeitszeiten/hooks/graphql/mutation';
import {
  Arbeitszeiten_AbwesenheitDeleteMutation,
  Arbeitszeiten_AbwesenheitDeleteMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useAbwesenheitDelete() {
  const [execute, result] = useMutation<
    Arbeitszeiten_AbwesenheitDeleteMutation,
    Arbeitszeiten_AbwesenheitDeleteMutationVariables
  >(ABWESENHEIT_DELETE, {
    refetchQueries: ['getArbeitszeitenByDateAndStandortId', 'GetToDos'],
  });

  const abwesenheitDelete = useCallback(
    (variables: Arbeitszeiten_AbwesenheitDeleteMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [abwesenheitDelete, result] as const;
}
